import { useConfig } from '../default-config';
import TranslationsConfigType from '../translations/translationType';

const useTranslation = (): TranslationsConfigType => {
    const { siteLang, translations } = useConfig();
    return translations[siteLang];
};

export default useTranslation;
